import { logPopupError } from "utils/Utils";
import { t } from "i18next";

const brands = "APPLEPAY VISA MASTER GOOGLEPAY";

const scriptSource = process.env.REACT_APP_AFS_ENV === "aslase-dev" ?
  "https://eu-test.oppwa.com/v1/paymentWidgets.js?checkoutId=" :
  "https://eu-prod.oppwa.com/v1/paymentWidgets.js?checkoutId=";

const getAmountToBePaid = ({
  paymentLinkInfo,
  isSplitted,
  ordered,
  totalOrdersGrossAmount,
  orderGrossAmount,
  split,
} = {}) => {
  const amount = paymentLinkInfo?.amount
    ? paymentLinkInfo?.amount
    : isSplitted
    ? split?.totalAmount
    : ordered?.allOrders?.length > 0
    ? totalOrdersGrossAmount
    : orderGrossAmount;
  return parseFloat(amount || 0);
};

const setAFSWplOptions = (afsPaymentData, settings = {}) => {
  return new Promise((resolve, reject) => {
    try {
      if (!afsPaymentData) {
        throw new Error("Payment data is missing");
      }

        var options = {
          // style: "plain",
          brandDetection: true,
          showCVVHint: true,
          ...(afsPaymentData?.entityId
            ? {
                googlePay: {
                  gatewayMerchantId: afsPaymentData?.entityId,
                  merchantId: "BCR2DN4T3XHI3P3F",
                  buttonType: "pay",
                  onCancel: (error) => {
                    console.log(error);
                    logPopupError(
                      "Unable to complete payment using google pay",
                      true
                    );
                  },
                },
              }
            : {}),
          applePay: {
            displayName: "REST HERO",
            version: 13,
            checkAvailability: "canMakePayments",
            // merchantIdentifier: "merchant.com.test",
            buttonType:"pay",
            onCancel: (error) => {
              console.log(error);
              logPopupError(
                "Unable to complete payment using apple pay",
                true
              );
            },
            onPaymentAuthorized: (data) => {
              console.log("Apple Pay payment authorized", data);
            },
          },

          onReady: function () {
            const cardGroup = document.querySelector(".wpwl-group-cardNumber");

            if (cardGroup) {
              const wrapper = document.createElement("div");
              wrapper.id = "card-number-wrapper";
              wrapper.style.display = "flex";
              wrapper.style.alignItems = "center";
              wrapper.style.gap = "24px";

              cardGroup.parentNode.insertBefore(wrapper, cardGroup);
              wrapper.appendChild(cardGroup);

              const defaultIcon = document.createElement("div");
              defaultIcon.id = "default-brand-icons";
              defaultIcon.className = "wpwl-brand wpwl-brand-brand wpwl-brand-card";
              defaultIcon.style.width = "50px";
              defaultIcon.style.height = "32px";
              defaultIcon.style.flexShrink = "0";
              defaultIcon.style.display = "none"; // hidden until valid

              wrapper.appendChild(defaultIcon);

              cardGroup.style.flex = "1 1 auto";
              cardGroup.style.padding = "0 !important";
            }

            const cvvGroup = document.querySelector(".wpwl-group-cvv");
            const holderGroup = document.querySelector(".wpwl-group-cardHolder");
            if (cvvGroup && holderGroup) {
              cvvGroup.insertAdjacentElement("afterend", holderGroup);
            }

            const payButton = document.querySelector(".wpwl-button-pay");
            if (payButton) {
              const container = document.createElement("div");
              container.id = "afs-total-price";
              container.className = "flex-1";
              container.textContent = `${t("Total Amount (inc. Tax)")}: ${
               afsPaymentData?.amount
              } AED`;
              payButton.textContent = t("Pay Now & Place Order");
              payButton.insertAdjacentElement("beforebegin", container);
            }

            const submitButton = document.querySelector(".wpwl-group-submit");
            if (submitButton) {
              const newDiv = document.createElement("div");
              newDiv.id = "afs-brand-icons";
              newDiv.className = "wpwl-label";
              // newDiv.textContent = "Supported Brands: ";
              const brandList = document.createElement("div");
              brandList.className = "flex items-center gap-2 flex-wrap";
              brands?.split(" ")?.forEach((brand) => {
                const brandDiv = document.createElement("div");
                brandDiv.className = `afs-brand-image wpwl-brand-${brand} wpwl-brand-card `;
                brandDiv.title = brand;
                brandList.appendChild(brandDiv);
              });
              newDiv.appendChild(brandList);
              submitButton.appendChild(newDiv);
            }
          },
          onChangeBrand: function (brand) {
            const defaultBrand = document.getElementById("default-brand-icons");
            const allowedBrands = brands?.split(" ");
            if (defaultBrand) {
              if (brand && allowedBrands?.includes(brand)) {
                defaultBrand.className = `wpwl-brand wpwl-brand-${brand} wpwl-brand-card`;
                defaultBrand.style.display = "block";
                defaultBrand.style.visibility = "visible";
                defaultBrand.style.opacity = "1";
              } else {
                // Restore original default class or hide it
                defaultBrand.className =
                  "wpwl-brand wpwl-brand-brand wpwl-brand-card";
                defaultBrand.style.display = "none";
                defaultBrand.style.visibility = "hidden";
              }
            }
          },
        };

     // var options = {
      //   applePay: {
      //     displayName: "REST HERO",
      //     version: 13,
      //     checkAvailability: "canMakePayments",
      //     merchantIdentifier: "merchant.com.test",
      //     buttonType: "pay",
      //     onLoad: () => {
      //       console.log("Apple Pay loaded");
      //     },
      //     onError: (error) => {
      //       console.log("Apple Pay error", error);
      //     },
      //     onCancel: () => {
      //       console.log("Apple Pay cancelled");
      //     },
      //   }, 
      // };

      window.wpwlOptions = options;

      resolve(afsPaymentData);
    } catch (error) {
      console.error("Failed to configure wpwlOptions:", error);
      reject(error);
    }
  });
};


// const applePayButton = () => {
//   window.wpwlOptions.applePay = {
//     displayName: "REST HERO",
//     version: 13,
//     checkAvailability: "canMakePayments",
//     merchantIdentifier: "merchant.com.test",
//     buttonType: "pay",
//     onCancel: () => {
//       console.log("Apple Pay cancelled");
//       logPopupError("Unable to complete payment using apple pay", true);
//     },
//   }
// }

export { brands, scriptSource, getAmountToBePaid, setAFSWplOptions };
